import React from "react";

import SimulatedHeader from "../Header";
import WaitingCard from "../WaitingCard";

import * as S from "./style";

const AnswersRegistered = (props) => {
  const {
    simulated,
    getRanking,
    onFeedbackRelease,
    whatsappUrl,
  } = props;

  const onTimerFinish = () => {
    if (typeof getRanking === "function") getRanking();
    if (typeof onFeedbackRelease === "function") onFeedbackRelease();
  };

  return (
    <S.Container>
      <SimulatedHeader simulated={simulated} />
      <S.WaitingWrapper>
        <S.CardFrame>
          <S.StarYellow>
            <svg
              viewBox="0 0 30.4338 28.9443"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M15.2169 0L18.8091 11.0557H30.4338L21.0292 17.8885L24.6215 28.9443L15.2169 22.1115L5.81234 28.9443L9.40456 17.8885L0 11.0557H11.6247L15.2169 0Z"
                fill="#F7D518"
                fillOpacity="0.7"
              />
            </svg>
          </S.StarYellow>
          <S.StarGreen>
            <svg
              viewBox="0 0 22.8254 21.7082"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M11.4127 0L14.1068 8.2918H22.8254L15.7719 13.4164L18.4661 21.7082L11.4127 16.5836L4.35925 21.7082L7.05342 13.4164L0 8.2918H8.71851L11.4127 0Z"
                fill="#0E8A3E"
                fillOpacity="0.5"
              />
            </svg>
          </S.StarGreen>
          <S.StarBlue>
            <svg
              viewBox="0 0 19.0211 18.0902"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M9.51056 0L11.7557 6.90983H19.0211L13.1433 11.1803L15.3884 18.0902L9.51056 13.8197L3.63271 18.0902L5.87785 11.1803L0 6.90983H7.26542L9.51056 0Z"
                fill="#0033A0"
                fillOpacity="0.4"
              />
            </svg>
          </S.StarBlue>
          <S.StarRed>
            <svg
              viewBox="0 0 17.119 16.2812"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M8.55951 0L10.5801 6.21885H17.119L11.8289 10.0623L13.8496 16.2812L8.55951 12.4377L3.26944 16.2812L5.29007 10.0623L0 6.21885H6.53888L8.55951 0Z"
                fill="#D62828"
                fillOpacity="0.4"
              />
            </svg>
          </S.StarRed>
          <WaitingCard
            releaseDate={simulated && simulated.rankingStartDate}
            whatsappUrl={whatsappUrl}
            onComplete={onTimerFinish}
          />
        </S.CardFrame>
      </S.WaitingWrapper>
    </S.Container>
  );
};

export default AnswersRegistered;
